import React, { useState, useEffect } from 'react';

// reserved / import config from '../config';
import { useLazyQuery } from '../hooks/graph';
import Icon from '../components/icon';
import { PriceFormat } from '../components/misc';
const controller = new AbortController();

function MeDashboardPaymentList({ account }) {
	const [ payments, setPayments ] = useState();
	const [ invoiceId, setInvoiceId ] = useState();

	const [ accountInvoiceRetrieve, { fetching: fetchingAccountInvoice } ] = useLazyQuery('accountInvoice', {
		requestPolicy: 'network-only',
		variables: {id: invoiceId},
	}, controller);

	useEffect(() => {
		try {
			setPayments((JSON.parse(account?.metadata) || {}).payments || []);
		}
		catch {
			// pass
		}
	}, [account]);

	useEffect(() => {
		invoiceId && accountInvoiceRetrieve().then(({ data: { accountInvoice } }) => {
			const url = accountInvoice.invoicePdf;
			const link = document.createElement('a');

			link.href = url;
			link.setAttribute('download', accountInvoice.id);
			document.body.appendChild(link);

			link.click();
			link.parentNode.removeChild(link);
		});
	}, [invoiceId]);

	useEffect(() => () => controller.abort(), []); // abort on unmount

	return payments ? (
		<div className="mb-4">
			<table className="table table-hover">
				<thead>
					<tr>
						<th scope="col">Recent payments</th>
						<th scope="col">Date<span className="d-inline d-lg-none">, Invoice</span></th>
						<th scope="col"><span className="d-none d-lg-table-cell">Invoice</span></th>
					</tr>
				</thead>
				{
					payments.length ? (
						<tbody>
							{
								payments.map(item =>
									<tr key={item.createdAt}>
										<td>{item.credits} signals{item.createdAt > 1698811200 ? ' per month' : ''} for {<PriceFormat value={item.price} />}</td>
										<td className="text-nowrap">{new Date((item.createdAt > 1000000000000 ? Math.round(item.createdAt / 1000) : item.createdAt) * 1000).toLocaleDateString()}</td>
										<td>
											<button type="button" onClick={() => !fetchingAccountInvoice && setInvoiceId(item.stripeInvoiceId)} href="#" title="Download" className="btn border-0 p-0">
												<Icon.CloudDownload />
											</button>
										</td>
									</tr>
								)
							}
						</tbody>
					) : (
						<tbody>
							<tr>
								<td colSpan="3" className="text-center">No payments</td>
							</tr>
						</tbody>
					)
				}
			</table>
		</div>
	) : false;
}

export default MeDashboardPaymentList;
